/* eslint-disable no-console */
import { Meteor } from 'meteor/meteor';
import { map, cloneDeep } from 'lodash';
import { withTracker } from 'meteor/react-meteor-data';
import { Dropdown, DropdownButton, Form, Button, InputGroup } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import Loading from '../Loading';
import Sources from '../../../api/Sources/Sources';
import Connectors from '../../../api/Connectors/Connectors';
import { TaskSchemaOut } from '../../../api/Tasks/TaskSchema';
import * as taskOps from '../../../api/Tasks/task-operations';
import tasksToRun from './runningTasks';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';

const { isBeta } = Meteor.settings.public;
const DEBUG_SERVER_IP = '2.136.192.212:30015'; // PATATA
const runTask = async (taskToRun, serverIP) => {
  const taskToSend = cloneDeep(taskToRun);
  const cleanedTask = TaskSchemaOut.clean(taskToSend);
  try {
    await methodPromise('tasks.runTask', { debugIP: serverIP, taskToRun: cleanedTask });
    console.log('task sent to run');
    console.log(taskToRun);
  } catch (error) {
    console.error(error);
    handleErrorInClient(error);
  }
};

const RunTaskItem = ({ task, serverIP }) => {
  const taskName = taskOps.getLabel(task);
  return (
    <Dropdown.Item as="button" onClick={() => runTask(task, serverIP)}>
      {taskName}
    </Dropdown.Item>
  );
};
RunTaskItem.propTypes = {
  task: PropTypes.object.isRequired,
  serverIP: PropTypes.string.isRequired
};

const DebugTasksUtility = ({ loading, stateRef, loadTasklist, isMonitor, gmsConnections }) => {
  if (!isBeta) return null;
  if (loading) return <Loading />;
  const [serverIP, setServerIP] = useState(DEBUG_SERVER_IP);
  const runTheseTasks = tasksToRun(Meteor.userId());
  // useImperativeHandle(ref, () => ({ serverIP }), [serverIP]);
  useEffect(() => {
    // eslint-disable-next-line
    stateRef.current = { serverIP };
  });
  return (
    <>
      <Form.Group>
        <Form.Label column>IP Pruebas</Form.Label>

        <InputGroup className="mb-3">
          {!isMonitor && (
            <Button onClick={loadTasklist} disabled={isMonitor}>
              Reload TaskList
            </Button>
          )}
          <div className="col-md-2">
            <Form.Control
              as="select"
              name="gmsConnection"
              defaultValue={DEBUG_SERVER_IP}
              onChange={event => setServerIP(event.target.value)}
            >
              {map(gmsConnections, ({ _id, ip, name, port, serverType }) => {
                if (serverType === 'GMS') {
                  return (
                    <option value={`${ip}:${port}`} key={_id}>
                      {name}
                    </option>
                  );
                }
                return false;
              })}
            </Form.Control>
          </div>
        </InputGroup>
        <div className="invisible">
          <DropdownButton id="tuns-tasks-debug" title="Run Task Debug">
            {map(runTheseTasks, task => (
              <RunTaskItem task={task} serverIP={serverIP} key={taskOps.getLabel(task)} />
            ))}
          </DropdownButton>
        </div>
      </Form.Group>
    </>
  );
};

DebugTasksUtility.propTypes = {
  loading: PropTypes.bool.isRequired,
  gmsConnections: PropTypes.array,
  loadTasklist: PropTypes.func,
  stateRef: PropTypes.object,
  isMonitor: PropTypes.bool
};

DebugTasksUtility.defaultProps = {
  gmsConnections: [],
  loadTasklist: () => console.log('reloadtasklist'),
  stateRef: {},
  isMonitor: false
};

export default withTracker(() => {
  const sourcesSub = Meteor.subscribe('sources');
  const connectorsSub = Meteor.subscribe('connectors');
  const gmsConnectionsSub = Meteor.isClient && Meteor.subscribe('gmsConnections');
  return {
    loading: !sourcesSub.ready() || !connectorsSub.ready() || !gmsConnectionsSub.ready(),
    sources: Sources.find({ deleted: { $eq: 'no' } }).fetch(),
    connectors: Connectors.find({ deleted: { $eq: 'no' } }).fetch(),
    gmsConnections: TelemetryConnections.find().fetch()
  };
})(DebugTasksUtility);
